<template>
  <div
    id="form-search-popover"
    class="component-card container-app-search">
    <j-title-header :options="title"/>

    <v-server-table
      v-show="load_first"
      ref="tableServer"
      :columns="columns"
      :options="options"
      class="jTable"
      @loading="loading"
      @loaded="loaded"
      @row-click="openEditModal">
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            v-if="!readOnly"
            class="btn grey btn-import-form m__r--5"
            @click="openCreateModal">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>

          <!-- <b-form
            inline
            @keypress.13.prevent="filter()">
            <j-select
              v-model="select_type"
              :options="options_search"
              placeholder="Filter By"
              class="m__r--5"/>
            <b-form-input
              v-model="filter_data"
              placeholder="Search"
              style="width: 250px !important; height: 33px;"/>
          </b-form> -->
        </b-form>
      </div>

      <!-- <div
        slot="keterangan"
        slot-scope="props">
        {{ props.row.waktu_keluar.includes('0000-00-00') ? 'Belum Keluar' : 'Sudah Keluar' }}
      </div> -->
    </v-server-table>
    <jLoadingTable v-if="!load_first"/>

    <b-modal
      ref="modalCreate"
      class="mod-form mod-form-big"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="text-align: center">Silahkan Masukan Data Tamu</h2>
      <b-row v-if="showModalCreate">
        <b-col md="4">
          <b-form-group :class="{'error-input' : $v.data_buku_tamu.nama.$error}">
            <label> Nama </label>
            <j-input
              v-model="$v.data_buku_tamu.nama.$model"
              placeholder="Nama"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_buku_tamu.instansi.$error}">
            <label> Instansi </label>
            <j-input
              v-model="$v.data_buku_tamu.instansi.$model"
              placeholder="Instansi"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_buku_tamu.tujuan.$error}">
            <label> Tujuan </label>
            <j-input
              v-model="$v.data_buku_tamu.tujuan.$model"
              placeholder="Tujuan"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_buku_tamu.waktu_masuk.$error}">
            <label> Waktu Masuk </label>
            <j-date-time
              :type="'datetime'"
              v-model="$v.data_buku_tamu.waktu_masuk.$model"
              :disabled="true"
              placeholder="Waktu Masuk"/>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group :class="{'error-input' : $v.data_buku_tamu.alamat.$error}">
            <label> Alamat </label>
            <j-input
              v-model="$v.data_buku_tamu.alamat.$model"
              placeholder="Alamat"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_buku_tamu.phone.$error}">
            <label> Telepon </label>
            <j-input
              v-model="$v.data_buku_tamu.phone.$model"
              placeholder="Telepon"
              type="number"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_buku_tamu.orang_dituju.$error}">
            <label> Orang Dituju </label>
            <j-single-select
              v-model="$v.data_buku_tamu.orang_dituju.$model"
              :options="list_pegawai"
              :placeholder="'Orang Dituju'"
              value-format="object"
              label="name"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_buku_tamu.keterangan.$error}">
            <label> Keterangan </label>
            <j-input
              v-model="$v.data_buku_tamu.keterangan.$model"
              placeholder="Keterangan"/>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group :class="{'error-input' : $v.data_buku_tamu.photo_ktp.$error}">
            <label> Photo KTP </label>
            <j-webcamp
              ref="webcampKtpCreate"
              :img-default="$v.data_buku_tamu.no_ktp.$model"
              :ref-id="'webcampKtpCreate'"
              @set-url="setUrlKTP"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_buku_tamu.no_ktp.$error}">
            <label> No KTP </label>
            <j-input
              v-model="$v.data_buku_tamu.no_ktp.$model"
              placeholder="No KTP"
              type="number"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_buku_tamu.photo_tamu.$error}">
            <label> Photo Tamu </label>
            <j-webcamp
              ref="webcampTamuCreate"
              :img-default="$v.data_buku_tamu.photo_tamu.$model"
              :ref-id="'webcampTamuCreate'"
              @set-url="setUrlTamu"/>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="float-to-right m__t--20">
        <b-button
          class="btn blue m__r--5"
          @click="saveData">
          Save
        </b-button>
        <b-button
          class="btn gray"
          @click="closeModalCreate">
          Cancel
        </b-button>
      </div>
    </b-modal>

    <b-modal
      ref="modalUpdate"
      class="mod-form mod-form-big"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="text-align: center">Update Data Tamu</h2>
      <b-row v-if="showModalUpdate">
        <b-col md="4">
          <b-form-group :class="{'error-input' : $v.data_buku_tamu.nama.$error}">
            <label> Nama </label>
            <j-input
              v-model="$v.data_buku_tamu.nama.$model"
              :disabled="readOnly"
              placeholder="Nama"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_buku_tamu.instansi.$error}">
            <label> Instansi </label>
            <j-input
              v-model="$v.data_buku_tamu.instansi.$model"
              :disabled="readOnly"
              placeholder="Instansi"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_buku_tamu.tujuan.$error}">
            <label> Tujuan </label>
            <j-input
              v-model="$v.data_buku_tamu.tujuan.$model"
              :disabled="readOnly"
              placeholder="Tujuan"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_buku_tamu.waktu_masuk.$error}">
            <label> Waktu Masuk </label>
            <j-date-time
              :type="'datetime'"
              v-model="$v.data_buku_tamu.waktu_masuk.$model"
              :disabled="true"
              placeholder="Waktu Masuk"/>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group :class="{'error-input' : $v.data_buku_tamu.alamat.$error}">
            <label> Alamat </label>
            <j-input
              v-model="$v.data_buku_tamu.alamat.$model"
              :disabled="readOnly"
              placeholder="Alamat"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_buku_tamu.phone.$error}">
            <label> Telepon </label>
            <j-input
              v-model="$v.data_buku_tamu.phone.$model"
              :disabled="readOnly"
              placeholder="Telepon"
              type="number"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_buku_tamu.orang_dituju.$error}">
            <label> Orang Dituju </label>
            <j-single-select
              v-model="$v.data_buku_tamu.orang_dituju.$model"
              :options="list_pegawai"
              :placeholder="'Orang Dituju'"
              :disabled="readOnly"
              value-format="object"
              label="name"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_buku_tamu.keterangan.$error}">
            <label> Keterangan </label>
            <j-input
              v-model="$v.data_buku_tamu.keterangan.$model"
              :disabled="readOnly"
              placeholder="Keterangan"/>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group :class="{'error-input' : $v.data_buku_tamu.photo_ktp.$error}">
            <label> Photo KTP </label><br>
            <img
              :src="$v.data_buku_tamu.photo_ktp.$model"
              width="150">
            <j-webcamp
              ref="webcampKtpUpdate"
              :img-default="$v.data_buku_tamu.no_ktp.$model"
              :ref-id="'webcampKtpUpdate'"
              :is-disabled="readOnly"
              class="m__t--20"
              @set-url="setUrlKTP"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_buku_tamu.no_ktp.$error}">
            <label> No KTP </label>
            <j-input
              v-model="$v.data_buku_tamu.no_ktp.$model"
              :disabled="readOnly"
              placeholder="No KTP"
              type="number"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_buku_tamu.photo_tamu.$error}">
            <label> Photo Tamu </label><br>
            <img
              :src="$v.data_buku_tamu.photo_tamu.$model"
              width="150">
            <j-webcamp
              ref="webcampTamuUpdate"
              :img-default="$v.data_buku_tamu.photo_tamu.$model"
              :ref-id="'webcampTamuUpdate'"
              :is-disabled="readOnly"
              class="m__t--20"
              @set-url="setUrlTamu"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="3">
          <!-- <b-button
            class="btn red m__t--20"
            @click="deleteData">
            Delete
          </b-button> -->
        </b-col>
        <b-col md="9">
          <div class="float-to-right m__t--20">
            <b-button
              v-if="!readOnly"
              class="btn blue m__r--5"
              @click="updateData">
              Update
            </b-button>
            <b-button
              class="btn gray"
              @click="closeModalUpdate">
              Cancel
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions } from 'vuex';
import { required, requiredIf } from 'vuelidate/lib/validators';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

import jApiHubin from '@/services/jApiHubin';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
import jWebcamp from '@/views/hubungan-dinas/buku-tamu/jWebcamp';

export default {
  components: {
    jLoadingTable,
    jWebcamp,
  },
  mixins: [
    jPrivRoles,
  ],
  data() {
    return {
      title: {
        icon: 'fa-file',
        main_title: 'Data Buku Tamu',
      },

      data_buku_tamu: {
        nama: '',
        alamat: '',
        instansi: '',
        phone: null,
        photo_ktp: null,
        no_ktp: null,
        tujuan: '',
        orang_dituju: null,
        waktu_masuk: null,
        waktu_keluar: null,
        keterangan: '',
        photo_tamu: null,
      },
      list_pegawai: [],
      mode: '',
      showModalCreate: false,
      showModalUpdate: false,
      filter_data: '',
      select_type: 'nama',
      options_search: [
        {
          text: 'Nama',
          value: 'nama',
        },
      ],
      load_first: false,
      data_table: [],
      columns: ['id', 'nama', 'waktu_masuk', 'tujuan', 'orang_dituju'],
      options: {
        headings: {
          id: 'ID',
          nama: 'NAMA',
          waktu_masuk: 'WAKTU MASUK',
          tujuan: 'TUJUAN',
          orang_dituju: 'ORANG DITUJU',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: [],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            limit: data.limit,
            page: data.page,
          };
        },
        requestFunction(data) {
          const getList = jApiHubin.getListBukuTamu(data);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
    this.listPegawai();
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),
    ...mapActions('jStoreHubin', ['createBukuTamu', 'updateBukuTamu']),
    ...mapActions('jStoreKurikulum', ['getListPegawai']),

    listPegawai() {
      this.getListPegawai().then((res) => {
        this.list_pegawai = res.data.data;
      });
    },

    loading(val) {
      const a = val;

      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;

      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    filter() {
      this.$refs.tableServer.getData();
    },

    setUrlKTP(params) {
      this.data_buku_tamu.photo_ktp = params;
    },

    setUrlTamu(params) {
      this.data_buku_tamu.photo_tamu = params;
    },

    openCreateModal() {
      this.mode = 'create';
      this.showModalCreate = true;
      this.$refs.modalCreate.show();
      this.data_buku_tamu.waktu_masuk = this.getDateTimeNow();
      setTimeout(() => {
        this.$v.data_buku_tamu.$reset();
      }, 100);
    },

    closeModalCreate() {
      this.$refs.modalCreate.hide();
      this.showModalCreate = false;
      this.data_buku_tamu = {
        nama: '',
        alamat: '',
        instansi: '',
        phone: null,
        photo_ktp: null,
        no_ktp: null,
        tujuan: '',
        orang_dituju: null,
        waktu_masuk: null,
        waktu_keluar: null,
        keterangan: '',
        photo_tamu: null,
      };
      setTimeout(() => {
        this.$v.data_buku_tamu.$reset();
      }, 1000);
    },

    closeModalUpdate() {
      this.$refs.modalUpdate.hide();
      this.showModalUpdate = false;
      this.data_buku_tamu = {
        nama: '',
        alamat: '',
        instansi: '',
        phone: null,
        photo_ktp: null,
        no_ktp: null,
        tujuan: '',
        orang_dituju: null,
        waktu_masuk: null,
        waktu_keluar: null,
        keterangan: '',
        photo_tamu: null,
      };
      setTimeout(() => {
        this.$v.data_buku_tamu.$reset();
      }, 1000);
    },

    openEditModal(param) {
      this.mode = 'update';
      this.showModalUpdate = true;
      this.$refs.modalUpdate.show();
      const pegawaiSelected = this.list_pegawai.find(f => f.name === param.row.orang_dituju);
      this.data_buku_tamu = {
        id: param.row.id,
        nama: param.row.nama,
        alamat: param.row.alamat,
        instansi: param.row.instansi,
        phone: param.row.phone,
        photo_ktp: param.row.photo_ktp,
        no_ktp: param.row.no_ktp,
        tujuan: param.row.tujuan,
        orang_dituju: pegawaiSelected || null,
        waktu_masuk: param.row.waktu_masuk ? this.convertTime(param.row.waktu_masuk) : null,
        waktu_keluar: param.row.waktu_keluar ? this.convertTime(param.row.waktu_keluar) : null,
        keterangan: param.row.keterangan,
        photo_tamu: param.row.photo_tamu,
      };
    },

    saveData() {
      this.$v.data_buku_tamu.$touch();
      if (!this.$v.data_buku_tamu.$error) {
        const params = this.data_buku_tamu;
        params.waktu_masuk = params.waktu_masuk ? this.$moment(params.waktu_masuk).format('YYYY-MM-DD HH:mm') : '';
        // params.waktu_keluar = params.waktu_keluar ? this.$moment(params.waktu_keluar).format('YYYY-MM-DD HH:mm') : '';
        params.orang_dituju = params.orang_dituju ? params.orang_dituju.name : '';
        this.createBukuTamu(params).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeModalCreate();
            }, 1500);
          }
        });
      }
    },

    updateData() {
      this.$v.data_buku_tamu.$touch();
      if (!this.$v.data_buku_tamu.$error) {
        const params = this.data_buku_tamu;
        params.waktu_masuk = params.waktu_masuk ? this.$moment(params.waktu_masuk).format('YYYY-MM-DD HH:mm') : '';
        params.waktu_keluar = params.waktu_keluar ? this.$moment(params.waktu_keluar).format('YYYY-MM-DD HH:mm') : '';
        params.orang_dituju = params.orang_dituju ? params.orang_dituju.name : '';
        this.updateBukuTamu(params).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeModalUpdate();
            }, 1500);
          }
        });
      }
    },

    getDateTimeNow() {
      const dt = new Date();
      const localDate = dt;

      const gmt = localDate;
      const min = gmt.getTime() / 1000 / 60; // convert gmt date to minutes
      const localNow = new Date().getTimezoneOffset(); // get the timezone
      const localTime = min + localNow; // get the local time

      const fullDate = new Date(localTime * 1000 * 60);
      const year = fullDate.getFullYear();
      const month = `0${fullDate.getMonth() + 1}`;
      const date = `0${fullDate.getDate()}`;
      const hours = `0${fullDate.getHours()}`;
      const minutes = `0${fullDate.getMinutes()}`;
      const utc = `${year}-${month.substr(-2)}-${date.substr(-2)}T${hours.substr(-2)}:${minutes.substr(-2)}:00.000Z`;

      console.log(utc);
      return utc;
    },

    convertTime(serverDate) {
      const dt = new Date(Date.parse(serverDate));
      const localDate = dt;

      const gmt = localDate;
      const min = gmt.getTime() / 1000 / 60; // convert gmt date to minutes
      const localNow = new Date().getTimezoneOffset(); // get the timezone
      const localTime = min + localNow; // get the local time

      const fullDate = new Date(localTime * 1000 * 60);
      const year = fullDate.getFullYear();
      const month = `0${fullDate.getMonth() + 1}`;
      const date = `0${fullDate.getDate()}`;
      const hours = `0${fullDate.getHours()}`;
      const minutes = `0${fullDate.getMinutes()}`;
      const utc = `${year}-${month.substr(-2)}-${date.substr(-2)}T${hours.substr(-2)}:${minutes.substr(-2)}:00.000Z`;

      return utc;
    },

    deleteData() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_buku_tamu.id,
          };
          this.deleteMitra(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalUpdate();
              }, 1500);
            }
          });
        }
      });
    },
  },
  validations() {
    return {
      data_buku_tamu: {
        nama: { required },
        alamat: { required },
        instansi: { required },
        phone: { required },
        photo_ktp: { },
        no_ktp: { required },
        tujuan: { required },
        orang_dituju: { required },
        waktu_masuk: {
          required: requiredIf(() => this.mode === 'create'),
        },
        waktu_keluar: {
          required: requiredIf(() => this.mode === 'update'),
        },
        keterangan: { },
        photo_tamu: { required },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/hubungan-dinas/buku-tamu/jBukuTamuList.vue